import { render, staticRenderFns } from "./RevenueDetail.vue?vue&type=template&id=5dae9dbd&scoped=true&"
import script from "./RevenueDetail.vue?vue&type=script&lang=js&"
export * from "./RevenueDetail.vue?vue&type=script&lang=js&"
import style0 from "./RevenueDetail.vue?vue&type=style&index=0&id=5dae9dbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae9dbd",
  null
  
)

export default component.exports